import ConversationItemParts, {
    HasLoadState,
    PendingConversationRequestState,
} from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import { INITIAL_MAX_ITEMS_TO_RETURN } from '../actions/loadConversation';

export default function createEmptyConversationItemParts(
    conversationId: string,
    conversationSortOrder: ConversationSortOrder
): ConversationItemParts {
    return {
        conversationId: { Id: conversationId },
        conversationNodeIds: [],
        conversationSortOrder: conversationSortOrder,
        canLoadMore: false,
        isLoadMoreInProgress: false,
        maxItemsToReturn: INITIAL_MAX_ITEMS_TO_RETURN,
        loadingState: {
            isLoading: false,
            hasLoadState: HasLoadState.notStarted,
        },
        pendingRequestState: PendingConversationRequestState.NotPending,
    };
}
